// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__spg_O","log":"ModalInventoryLogs_log__e4k-N","date":"ModalInventoryLogs_date__1AOGi","userName":"ModalInventoryLogs_userName__2eymm"};